import React from 'react';
import { Eye, FileText, User } from 'lucide-react';
import { Invoice } from '../../types/invoice';

interface InvoiceCardProps {
  invoice: Invoice;
  onEdit?: (invoice: Invoice) => void;
  getStatusColor?: (status: string) => string;
}

const backendUrl = import.meta.env.VITE_CHOCO_URL;

const InvoiceCard: React.FC<InvoiceCardProps> = ({
  invoice,
  onEdit,
  getStatusColor,
}) => {
  const statusColor = getStatusColor?.(
    invoice?.paymentStatus || invoice?.status || ''
  );

  const handlePdfPreview = () => {
    window.open(
      `${backendUrl}/invoice/pdf/preview/${invoice?.invoiceFor}/${invoice?.id}`,
      '_blank'
    );
  };

  return (
    <div className="bg-white dark:bg-zinc-900 border border-greyFifty dark:border-zinc-700 rounded-xl cursor-pointer shadow-sm px-4 pt-4 pb-2 transition hover:shadow-md flex flex-col justify-between">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-base font-semibold text-blackFourty dark:text-white">
          {invoice.invoiceNumber}
        </div>
        <span
          className={`text-xs font-medium px-3 py-1 rounded-lg border ${statusColor}`}
        >
          {(invoice.paymentStatus || invoice.status)?.toUpperCase()}
        </span>
      </div>

      {/* Bill To */}
      <div className="flex items-center gap-2 text-sm text-zinc-600 dark:text-zinc-300 my-2">
        <User className="w-4 h-4" />
        <span>{invoice.billTo?.name}</span>
      </div>

      {/* Main Info Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <div className="flex items-center gap-2">
          Billed{' '}
          <p className="text-sm font-semibold text-zinc-800 dark:text-white">
            {/* {data.currency} {data.totalAmount} */}
            {invoice.displayAmount}
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-xs text-zinc-500 dark:text-zinc-400">
          Service Period {invoice.servicePeriod?.display}
        </p>
        <div className="flex gap-2">
          {onEdit && (
            <div className="flex items-center gap-1 justify-end">
              <button
                onClick={handlePdfPreview}
                className="p-1 rounded-md text-blackTen hover:bg-greyTwenty dark:text-blue-400 hover:underline"
              >
                <FileText size={14} />
              </button>
              <button
                onClick={() => onEdit?.(invoice)}
                className="p-1 rounded-md text-blackTen hover:bg-greyTwenty dark:text-blue-400 hover:underline"
              >
                <Eye size={14} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceCard;
